// src/shared/components/SessionTimeoutModal.tsx
// Reescrito sobre o Modal genérico do UI kit (nova identidade)

import React, { useState, useEffect } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  timeRemaining: number; // em milissegundos
  onExtendSession: () => void;
  onLogout: () => void;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  timeRemaining,
  onExtendSession,
  onLogout,
}) => {
  const [countdown, setCountdown] = useState<number>(0);

  useEffect(() => {
    if (isOpen) {
      setCountdown(Math.ceil(timeRemaining / 1000));
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isOpen, timeRemaining, onLogout]);

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      closeOnBackdrop={false}
      closeOnEsc={false}
      size="sm"
      data-testid="session-timeout-modal"
      footer={
        <>
          <Button variant="ghost" onClick={onLogout}>
            Sair agora
          </Button>
          <Button variant="primary" onClick={onExtendSession} data-testid="session-extend">
            Continuar sessão
          </Button>
        </>
      }
    >
      <div className="flex flex-col items-center gap-4 py-2 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-warning/10 text-warning">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </span>
        <div>
          <h2 className="font-display text-lg font-semibold text-foreground">Sessão expirando</h2>
          <p className="mt-1 text-sm text-foreground-muted">Sua sessão expirará por inatividade em:</p>
        </div>
        <div className="font-display text-3xl font-bold tabular-nums text-foreground">{formattedTime}</div>
        <p className="max-w-xs text-sm text-foreground-muted">
          Clique em “Continuar sessão” para permanecer logado, ou você será desconectado automaticamente.
        </p>
      </div>
    </Modal>
  );
};

export default SessionTimeoutModal;
